@let component = customComponent();
@if (component) {
  <ng-container *ngComponentOutlet="component"/>
} @else {
  <div class="wysiwig" [innerHTML]="markdown.value()"></div>
}
<homey-lotteries-and-footer/>
